<template>
  <div class="items pt-3">
    <!-- Items Requests -->
    <div  v-if="(route_name == 'Avantages' || route_name == 'Financement') && (complRequest.length>0 || currRequest.length>0)">
      <h2
        class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b uppercase"
      >{{ $t('requests.my_requests') }}</h2>
      <div class="list-reset flex border-b border-gray-light mb-4">
        <button
          v-for="(item, index) in items_requests"
          :key="item"
          :class="{active : currentTab === index }"
          @click="currentTab = index"
          class="bg-white inline-block rounded-t capitalize py-2 px-4 text-blue"
        >
          <h4 class="text-blue text-lg-2 normal-case">{{item}}</h4>
        </button>
      </div>
    </div>

    <!-- Items Declarations -->
    <div v-else-if="(route_name == 'Declarations' || route_name == 'sessionlessDeclaration') && (complRequestDeclarations.length>0 || currRequestDeclarations.length>0)">
      <h2 class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b uppercase">
        {{ route_name === 'sessionlessDeclaration' ? $t('demandes.histo_demandes') : $t('declarations.histo_declarations') }}
      </h2>

      <div class="list-reset flex border-b border-gray-light mb-4">
        <button
          v-for="(item, index) in items_declarations"
          :key="item"
          :class="{active : currentTab === index }"
          @click="currentTab = index"
          class="bg-white inline-block rounded-t capitalize py-2 px-4 text-blue"
        >
          <h4 class="text-blue text-lg-2 normal-case">{{item}}</h4>
        </button>
      </div>
    </div>

    <div class="tab-content text-2sm">
      <div v-show="currentTab === 0" class="text-red pb-2 my-4">
        <!-- Current Requests Avantages -->
        <div
          class="table-responsive bg-white shadow-md rounded my-6"
          v-if="(route_name == 'Avantages' || route_name == 'Financement') && currRequest.length>0"
        >
          <table class="text-left w-full border-collapse">
            <!--Border collapse doesn't work on this site yet but it's available in newer tailwind versions -->
            <thead>
              <tr>
                <th
                  class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                >{{ $t("requests.date_of_the_request") }}</th>
                <th v-if="route_name != 'Financement'"
                  class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                >{{ $t("requests.advantage_type") }}</th>
                <th
                  class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                >{{ $t("requests.status") }}</th>
                <th
                  class="py-4 px-22 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                >{{ $t("requests.actions") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="hover:bg-grey-lighter"
                v-for="(currReq, index) in currRequest"
                :key="index"
              >
                <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                  <span
                    v-if="currReq.created_at"
                  >{{new Date(currReq.created_at) | dateFormat('DD/MM/YYYY')}}</span>
                </td>
                <td class="py-4 px-6 border-b border-grey-light text-grey-dark" v-if="route_name != 'Financement'">
                  <span v-if="currReq.type_id == 1">{{$t("requests.request_brevet")}}</span>
                  <span v-if="currReq.type_id == 2">{{$t("requests.request_douane")}}</span>
                  <span v-if="currReq.type_id == 3">{{$t("requests.request_leave")}}</span>
                  <span v-if="currReq.type_id == 4  && !('case' in currReq)">{{$t("requests.request_bourse")}}</span>
                  <span v-if="currReq.type_id == 4 && ('case' in currReq && currReq.case == 'remove_bourse')">{{$t("requests.stop_bourse_request")}}</span>
                  <span v-if="currReq.type_id == 5">{{$t("requests.request_prelabel_label")}}</span>
                  <span v-if="currReq.type_id == 6">{{$t("requests.request_cnss")}}</span>
                  <span v-if="currReq.type_id == 11">{{$t("requests.request_for_financing")}}</span>
                  <span v-if="currReq.type_id == 12">{{$t("requests.stop_bourse_request")}}</span>
                  <span v-if="currReq.type_id == 13">{{$t("requests.stop_leave_request")}}</span>
                  <span v-if="currReq.type_id == 14">{{$t("requests.extend_leave_request")}}</span>
                  <!--<span v-if="currReq.type_id == 15">{{$t("requests.request_support_patent")}}</span>-->
                </td>
                <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                  <span v-if="currReq.status == 0">{{$t("requests.new_request")}}</span>
                  <span v-if="currReq.status == 1">{{$t("requests.pending_request")}}</span>
                  <span v-if="currReq.status == 4">{{$t("requests.invalid_request")}}</span>
                  <span v-if="currReq.status == 5">{{$t("requests.aneti_request")}}</span>
                   <span v-if="currReq.status == 6">{{$t("requests.douane_request")}}</span>
                   <span v-if="currReq.status == 7">{{$t("requests.waiting_response_from_employer")}}</span>
                   <span v-if="currReq.status == 8 || currReq.status == 9">{{$t("requests.pending_request")}}</span>
                   <span v-if="currReq.status == 13">{{$t("requests.innorpi_request")}}</span>
                </td>
                <td class="py-4 px-6 border-b border-grey-light text-blue">
                  <sp-button
                    v-if="currReq.status != 1 && currReq.status != 5 && currReq.status != 0 && currReq.status != 6 && currReq.status != 7 && currReq.status != 8 && currReq.status != 9 && currReq.status != 13"
                    v-on:click="edit(currReq.type_id,currReq.hash_id,currReq.code_label)"
                    space="small"
                    theme="outline-blue"
                    type="submit"
                    class="w-3/4"
                  >{{ $t('requests.edit') }}</sp-button>
                  <sp-button
                    v-if="currReq.status != 4"
                    v-on:click="show(currReq.hash_id,currReq.type_id,currReq.code_label)"
                    space="small"
                    theme="outline-blue"
                    type="submit"
                    class="w-3/4"
                  >{{ $t('requests.consult') }}</sp-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Current Requests Declarations -->
        <div v-else-if="currRequestDeclarations.length>0">
          <div class="table-responsive bg-white shadow-md rounded my-6 mt-0">
            <table class="text-left w-full border-collapse">
              <!--Border collapse doesn't work on this site yet but it's available in newer tailwind versions -->
              <thead>
                <tr>
                  <th
                    class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                  >{{ $t("declarations.date_of_the_declaration") }}</th>
                  <th
                    class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                  >{{ $t("declarations.declaration_type") }}</th>
                  <th
                    class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                  >{{ $t("declarations.status") }}</th>
                  <th
                    class="py-4 px-22 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                  >{{ $t("requests.actions") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="hover:bg-grey-lighter"
                  v-for="(currDec, index) in currRequestDeclarations"
                  :key="index"
                >
                
                  <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                    <span
                      v-if="currDec.created_at"
                    >{{new Date(currDec.created_at) | dateFormat('DD/MM/YYYY')}}</span>
                  </td>
                  <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                    <span>{{$t(`${currDec.name}`)}}</span>
                  </td>
                  <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                    <span v-if="currDec.status == 0">{{$t("requests.new_request")}}</span>
                    <span v-if="currDec.status == 1">{{$t("requests.pending_request")}}</span>
                    <span v-if="currDec.status == 4">{{$t("requests.invalid_request")}}</span>
                    <span v-if="currDec.status == 5">{{$t("requests.sotugar_request")}}</span>
                  </td>
                  <td class="py-4 px-6 border-b border-grey-light text-blue text-right">
                    <sp-button
                      v-if="currDec.status == 4"
                      v-on:click="edit_declaration(currDec.appType.toLowerCase(),(currDec.code_name.toLowerCase()).replaceAll('_', '-'),currDec.hash_id)"
                      space="small"
                      theme="outline-blue"
                      type="submit"
                      class="w-3/4"
                    >{{ $t('requests.edit') }}</sp-button>
                    <sp-button
                      v-if="currDec.status != 4"
                      v-on:click="show_declaration(currDec.appType.toLowerCase(), currDec.code_name.toLowerCase().replaceAll('_', '-'), currDec.hash_id)"
                      space="small"
                      theme="outline-blue"
                      type="submit"
                      class="w-3/4"
                    >{{ $t('requests.consult') }}</sp-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div v-show="currentTab === 1" class="text-red pb-2 my-4">
        <!-- Completed requests -->
        <!--<h3 class="card-title text-bold uppercase pt-2">{{$t("requests.list_completed_requests")}}</h3>-->
        <!---->

        <!-- Completed Requests Avantages -->
        <div
          class="table-responsive bg-white shadow-md rounded my-6"
          v-if="(route_name == 'Avantages' || route_name == 'Financement') && complRequest.length>0"
        >
          <table class="text-left w-full border-collapse">
            <!--Border collapse doesn't work on this site yet but it's available in newer tailwind versions -->
            <thead>
              <tr>
                <th
                  class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                >{{ $t("requests.date_of_the_request") }}</th>
                
                <th v-if="route_name != 'Financement'"
                  class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                >{{ $t("requests.advantage_type") }}</th>
                <th
                  class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                >{{ $t("requests.status") }}</th>
                <th
                  class="py-4 px-22 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                >{{ $t("requests.actions") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="hover:bg-grey-lighter"
                v-for="(complReq, index) in complRequest"
                :key="index"
              >
                <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                  <span
                    v-if="complReq.created_at"
                  >{{new Date(complReq.created_at)| dateFormat('DD/MM/YYYY')}}</span>
                </td>
                <td class="py-4 px-6 border-b border-grey-light text-grey-dark" v-if="route_name != 'Financement'">
                  <span v-if="complReq.type_id == 1">{{$t("requests.request_brevet")}}</span>
                  <span v-if="complReq.type_id == 2">{{$t("requests.request_douane")}}</span>
                  <span v-if="complReq.type_id == 3">{{$t("requests.request_leave")}}</span>
                  <span v-if="complReq.type_id == 4 && complReq.status != 10">{{$t("requests.request_bourse")}}</span>
                  <span v-if="complReq.type_id == 4 && complReq.status == 10">{{$t("requests.request_stop_bourse")}}</span>
                  <span v-if="complReq.type_id == 5">{{$t("requests.request_prelabel_label")}}</span>
                  <span v-if="complReq.type_id == 6">{{$t("requests.request_cnss")}}</span>
                  <span v-if="complReq.type_id == 12">{{$t("requests.stop_bourse_request")}}</span>
                  <span v-if="complReq.type_id == 13">{{$t("requests.stop_leave_request")}}</span>
                  <span v-if="complReq.type_id == 14">{{$t("requests.extend_leave_request")}}</span>
                  <!--<span v-if="complReq.type_id == 15">{{$t("requests.request_support_patent")}}</span>-->
                </td>
                <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                  <span v-if="complReq.status == 2">{{$t("requests.accepted_request")}}</span>
                  <span v-if="complReq.status == 3">{{$t("requests.refused_request")}}</span>
                  <span v-if="complReq.status == 10">{{$t("requests.removed_bourse")}}</span>
                  <span v-if="complReq.status == 11">{{$t("requests.leave_removed")}}</span>
                  <span v-if="complReq.status == 12">{{$t("requests.leave_extended")}}</span>
                </td>
                <td class="py-4 px-6 border-b border-grey-light text-blue">
                  <sp-button
                    theme="outline-blue"
                    @click="show(complReq.hash_id,complReq.type_id,complReq.code_label)"
                    space="small"
                    type="submit"
                    class="w-3/4"
                  >{{ $t('requests.consult') }}</sp-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Completed Requests Declarations -->
        <div
          class="table-responsive bg-white shadow-md rounded my-6 mt-0"
          v-else-if="complRequestDeclarations.length>0"
        >
          <table class="text-left w-full border-collapse">
            <!--Border collapse doesn't work on this site yet but it's available in newer tailwind versions -->
            <thead>
              <tr>
                <th
                  class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                >{{ $t("declarations.date_of_the_declaration") }}</th>
                <th
                  class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                >{{ $t("declarations.declaration_type") }}</th>
                <th
                  class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                >{{ $t("declarations.status") }}</th>
                <th
                  class="py-4 px-22 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                >{{ $t("requests.actions") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="hover:bg-grey-lighter"
                v-for="(compReqDec, index) in complRequestDeclarations"
                :key="index"
              >
                <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                  <span
                    v-if="compReqDec.created_at"
                  >{{new Date(compReqDec.created_at)| dateFormat('DD/MM/YYYY')}}</span>
                </td>
                <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                    <span>{{ compReqDec.name }}</span>
                </td>
                <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                  <span v-if="compReqDec.status == 2">{{$t("requests.accepted_request")}}</span>
                  <span v-if="compReqDec.status == 3">{{$t("requests.refused_request")}}</span>
                </td>
                <td class="py-4 px-6 border-b border-grey-light text-blue">
                  <sp-button
                    theme="outline-blue"
                    @click="show_declaration(compReqDec.appType, compReqDec.code_name.toLowerCase().replaceAll('_', '-'), compReqDec.hash_id)"
                    space="small"
                    type="submit"
                    class="w-3/4"
                  >{{ $t('requests.consult') }}</sp-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import { mapGetters } from "vuex";
import {
  FETCH_APPLICATION,
  CLEAR_SAVE_MESSAGE,
  GET_CURRENT_REQUESTS_DECLARATIONS,
  GET_COMPLETED_REQUESTS_DECLARATIONS
} from "@/store/actions.type";
import ButtonVue from "../../components/spKit/Button.vue";
import store from "@/store";
export default {
  name: "items",
  components: {
    "sp-button": ButtonVue
  },
  props: {
        standardAdvantage: {
            required: false,
            type: Boolean,
            default: null
        },
    },
  data() {
    return {
      startupRequest: null,
      currRequest: [],
      complRequest: [],
      currRequestDeclarations: [],
      complRequestDeclarations: [],
      newRequest: [],
      requests: null,
      currentTab: 0,
      items_requests: [
        this.$t("requests.pending_requests"),
        this.$t("requests.completed_requests")
      ],
      items_declarations: [
        this.$t("declarations.declarations_pending"),
        this.$t("declarations.completed_declarations")
      ],
      route_name: null
    };
  },
  mounted() {
    this.route_name = this.$route.name;
    let id = localStorage.getItem('ecosystem') === 'true'
    ? (this.ecosystemApp && this.ecosystemApp.application && this.ecosystemApp.application.user_id)
    : (this.session && this.session.startup_application && this.session.startup_application.user_id);
    if (
      localStorage.getItem('ecosystem') !== 'true' &&
      (this.route_name != "sessionlessDeclaration") &&
      (this.session.startup_application == null ||
      this.route_name == "Avantages" || this.route_name == "Financement")
    ) {
      this.$store
        .dispatch(FETCH_APPLICATION, this.$route.params.app_id)
        .then(() => {
           this.currentRequest();
           this.completedRequest();
        });
    } else {
      // Current declarations
      this.$store
        .dispatch(GET_CURRENT_REQUESTS_DECLARATIONS, this.$route.params.app_id)
        .then(data => {
          this.currRequestDeclarations = data;
        });
      // Completed declarations
      this.$store
        .dispatch(
          GET_COMPLETED_REQUESTS_DECLARATIONS,
          this.$route.params.app_id
        )
        .then(data => {
          this.complRequestDeclarations = data;
        });
    }
  },
  methods: {
    /* Current Requests */
    currentRequest() {
      let id = this.session.user_auth.id;

      if(this.route_name === "Financement"){
        ApiService.get(
        `api/request/current_requests/${id}/${this.LabelApplication}/funding`
        )
        .then(data => {
          this.currRequest = data.data.data.CurrentRequests;
        })
        .catch(response => {
          console.log(response);
        });
      }else{
        ApiService.get(
        `api/request/current_requests/${id}/${this.LabelApplication}`
        )
        .then(data => {
          this.currRequest = data.data.data.CurrentRequests;
        })
        .catch(response => {
          console.log(response);
        });
      }
    },
    /* Completed Requests */
    completedRequest() {
      let id = this.session.user_auth.id;
      if(this.route_name === "Financement"){
        ApiService.get(
        `api/request/completed_requests/${id}/${this.LabelApplication}/funding`)
        .then(data => {
          this.complRequest = data.data.data.CompletedRequests;
        })
        .catch(response => {
          console.log(response);
        });
      }else{
        ApiService.get(
        `api/request/completed_requests/${id}/${this.LabelApplication}`)
        .then(data => {
          this.complRequest = data.data.data.CompletedRequests;
        })
        .catch(response => {
          console.log(response);
        });
      }
      
    },
    // Show detail request
    show(request_id, id, code_label) {
      this.$router.push({
        name: this.route_name == "Financement" ? "StartupFundingRequest" : "StartupRequest",
        params: {
          code_label: code_label,
          request_id: request_id,
          id: id
        }
      });
    },
    // Edit detail request
    edit(id, request_id, code_label) {
      this.$router.push({
        name: "StartupRequestEdit",
        params: {
          code_label: code_label,
          id: id,
          request_id: request_id
        }
      });
    },
    // Show detail declaration
    show_declaration(appType, formName, declarationId) {
      this.$router.push({
        name: "DeclarationRequest",
        params: {
          appType: appType,
          formName: formName.toLowerCase(),
          declarationId: declarationId
        }
      });
    },
    // Efit detail declaration
    edit_declaration(appType, formName, declarationId) {
      this.$router.push({
        name: "DeclarationEdit",
        params: {
          appType: appType,
          formName: formName,
          declarationId: declarationId
        }
      });
    }
  },
  computed: {
    ...mapGetters(["session", "hashId", "LabelApplication"])
  },
  watch: {
    standardAdvantage(){
      this.standardAdvantage ? this.route_name = "Avantages" : this.route_name = "Financement"
      let id = this.session.startup_application.user_id;
      this.$store
        .dispatch(FETCH_APPLICATION, this.$route.params.app_id)
        .then(() => {
           this.currentRequest();
           this.completedRequest();
        });
    }
  }
};
</script>

<style scoped>
button.active {
  background-color: #e7eaf1;
}
.tab-content div {
  padding: 20px 0 20px 0;
  padding-top: 0.5rem;
  padding-bottom: 0rem;
}
.list-reset {
  border-color: #c5cedc;
}
.border-grey-light {
  border-color: #dde1e7;
}
.text-grey-dark {
  color: #7d8593;
}
.title-tabs {
  font-size: 1.13rem;
}
.card-title {
  font-size: 1.1rem;
}
/*.text-base {
  font-size: 0.88rem;
}*/
</style>
